export function getRatio(ratio = "1/1"): string {
  const [ width, height ] = ratio.split("/")
  return `calc(100% / ${width} * ${height})`
}
